import { motion, useReducedMotion } from "framer-motion";

// Inner-page hero. Dark, premium, with kicker + title + optional lead.
// LCP-optimiert: die H1 wird ohne opacity-Gate gerendert (sofort sichtbar,
// LCP-fähig beim ersten Paint), nur ein leichter Transform-Slide als Motion.
export default function PageHero({ kicker, title, lead, children }) {
  const reduce = useReducedMotion();
  const fade = reduce
    ? {}
    : { initial: { opacity: 0, y: 12 }, animate: { opacity: 1, y: 0 } };
  // H1: kein opacity:0 (sonst LCP-verzögerung), nur Transform (kein Layout-Shift).
  const titleAnim = reduce ? {} : { initial: { y: 20 }, animate: { y: 0 } };

  return (
    <section className="relative overflow-hidden bg-brand-black grain">
      <div className="container-page relative z-10 pb-16 pt-16 md:pb-20 md:pt-20">
        {kicker && (
          <motion.span
            {...fade}
            transition={{ duration: 0.5 }}
            className="kicker text-yellow"
          >
            {kicker}
          </motion.span>
        )}
        <motion.h1
          {...titleAnim}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="mt-4 max-w-4xl font-heading text-4xl font-extrabold tracking-tight text-white md:text-5xl lg:text-6xl"
        >
          {title}
        </motion.h1>
        {lead && (
          <motion.p
            {...fade}
            transition={{ duration: 0.7, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="mt-6 max-w-2xl text-base leading-relaxed text-light-gray/70 md:text-lg"
          >
            {lead}
          </motion.p>
        )}
        {children}
      </div>
      <div className="pointer-events-none absolute -right-32 top-0 h-80 w-80 rounded-full bg-yellow/10 blur-3xl" />
    </section>
  );
}
